import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierSW-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import SWPolicyChangesPage from './pages/SWPolicyChanges/SWPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierSWPolicyChangesPage: { component: 'PremierSWPolicyChangesPage' }
    },
    {
        PremierSWPolicyChangesPage: SWPolicyChangesPage
    }
);

export { default as PremierSWPolicyChangeWizard } from './PremierSWPolicyChangeWizard';
